<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Atendimentos") }}
      </h1>
      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Atendimentos"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group
          id="dropdown-group-1"
          header="Relatórios de Atendimentos"
        >
          <b-dropdown-item
            :to="'/dashboard/relatorios/atendimentos/home'"
            :disabled="$route.name == 'relatorios_home_atendimentos'"
          >
            Todos os Atendimentos
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/atendimentos/graficos'"
            :disabled="$route.name == 'graficos_atendimentos'"
          >
            Gráficos de Atendimentos
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsAtendimentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Atendimentos"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
